import React from "react";
import {Helmet} from "react-helmet";
import {MichaelIsles} from "../../constants/meta";

export const A30Meta = () => (
    <Helmet>
        <title>Michael Isles | Vieunite </title>
        <meta name="twitter:card" value="summary"/>
        <meta name="twitter:site" value="@VieuniteHQ"/>
        <meta name="twitter:title" value="Vieunite Artist | Michael Isles"/>
        <meta name="twitter:description"
              content=". Minimalism and mindfulness are two descriptors that Michael feels work well with his photography. Mindfulness can be said to be the conscious awareness of the moment, Michael’s intention being to provide a space for the viewer to become absorbed in. "/>
        <meta name="twitter:url" value="https://vieunite.com/artists/michael-isles"/>
        <meta name="twitter:image" value="https://vieunite.com/images/vieunite_sc_michael_isles.jpg"/>

        <meta property="og:url" content="https://vieunite.com/artists/michael-isles"/>
        <meta property="og:type" content="website"/>
        <meta property="og:title" content="Vieunite Artist | Michael Isles"/>
        <meta property="og:description"
              content="Minimalism and mindfulness are two descriptors that Michael feels work well with his photography. Mindfulness can be said to be the conscious awareness of the moment, Michael’s intention being to provide a space for the viewer to become absorbed in. "/>
        <meta property="og:image" content="https://vieunite.com/images/vieunite_sc_ michael_isles.jpg"/>


    </Helmet>);